// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as RestApi$DvmAdminFrontendFr from "../../../api/RestApi.bs.js";
import * as Flash_Publish_Types$DvmAdminFrontendFr from "./Flash_Publish_Types.bs.js";

function fetchPublishResults(userManager, setResult, queryParams, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Flash_Publish_Types$DvmAdminFrontendFr.PublishTable.searchResult_decode, undefined, userManager, selectedRole, "/export/status" + queryParams + "").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var searchTable = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: searchTable
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function fetchPublishState(userManager, setResult, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.call("GET", Flash_Publish_Types$DvmAdminFrontendFr.publishStatusList_decode, undefined, userManager, selectedRole, "/export/running/status?executableBatchJob=MOVE_ACTIONS_MODEL_VERSIONS_EXPORT").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          var status = result._0;
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: status
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

function runFlashPublish(userManager, setResult, selectedRole) {
  Curry._1(setResult, (function (param) {
          return /* Pending */1;
        }));
  RestApi$DvmAdminFrontendFr.WithEmptyResponse.call("PUT", undefined, userManager, selectedRole, "/export/actions?executableBatchJob=MOVE_ACTIONS_MODEL_VERSIONS_EXPORT").then(function (result) {
        if (result.TAG === /* OkResult */0) {
          return Curry._1(setResult, (function (param) {
                        return {
                                TAG: /* Ok */0,
                                _0: undefined
                              };
                      }));
        }
        var error = result._0;
        Curry._1(setResult, (function (param) {
                return {
                        TAG: /* Error */1,
                        _0: error
                      };
              }));
      });
}

var Types;

export {
  Types ,
  fetchPublishResults ,
  fetchPublishState ,
  runFlashPublish ,
}
/* RestApi-DvmAdminFrontendFr Not a pure module */
